import { Host, h } from "@stencil/core";
const selectionFormat = 'selection';
const multiselectionFormat = 'multi-selection';
const actionFormat = 'action';
const selectedClass = 'item--selected';
const disabledClass = 'item--disabled';
let id = 0;
export class CoreDropdownSection {
    constructor() {
        this.sectionIdIncremented = `dropdown-section-${++id}`;
        // make sure checkbox can be toggled on click on the list item
        this.toggleCheckbox = (item) => {
            if (item.disabled)
                return;
            item.selected = !item.selected;
            // force rerender with new values
            this.currentItems = Object.assign({}, this.currentItems);
        };
        this.renderMultiSelectionItems = () => {
            if (this.format !== multiselectionFormat)
                return;
            return (h("ul", null, this.currentItems.items.map(item => {
                return (h("li", { class: `item typography-body-medium-regular ${item.disabled ? disabledClass : ''} ${item.selected ? 'item--selected' : ''}`, tabIndex: item.disabled ? -1 : 0, "aria-disabled": item.disabled, onClick: () => {
                        this.toggleCheckbox(item);
                    }, onKeyDown: e => {
                        ;
                        (e.key === 'Enter' || e.key === ' ') && this.toggleCheckbox(item);
                    } }, h("span", { class: "item-content" }, h("core-checkbox", { tabIndex: -1, class: "item-content", format: "right", label: item.label, description: item.description, value: item.value, disabled: item.disabled, checked: item.selected })), h("i", { class: "item-indicator" }, item.disabled && (h("span", { class: "icon-box" }, h("core-icon", { name: "lock-solid", size: "number-size-icon-large" }))))));
            })));
        };
        this.renderSelectionItems = () => {
            if (this.format !== selectionFormat)
                return;
            return (h("ul", null, this.currentItems.items.map(item => {
                return (h("li", { class: `item typography-body-medium-regular ${item.disabled ? disabledClass : ''} ${item.selected ? selectedClass : ''}`, tabIndex: item.disabled ? -1 : 0, "aria-disabled": item.disabled, onClick: event => {
                        this.toggleSelectItem(event, item);
                    }, onKeyDown: event => {
                        ;
                        (event.key === 'Enter' || event.key === ' ') && this.toggleSelectItem(event, item);
                    } }, h("span", { class: "item-content" }, item.iconName && (h("span", { class: "icon-box" }, h("core-icon", { name: item.iconName, size: "number-size-icon-large" }))), h("span", { class: "text-box" }, h("span", { class: "item-label" }, item.label), item.description && h("span", { class: "item-description typography-body-small-regular" }, item.description))), h("i", { class: "item-indicator" }, item.selected && (h("span", { class: "icon-box" }, h("core-icon", { name: "check_mark-outline", fill: "currentcolor", size: "number-size-icon-large" }))), item.disabled && (h("span", { class: "icon-box" }, h("core-icon", { name: "lock-solid", size: "number-size-icon-large" }))))));
            })));
        };
        this.renderActionItems = () => {
            if (this.format !== actionFormat)
                return;
            return (h("ul", null, h("slot", null)));
        };
        this.renderItems = () => {
            if (this.format === multiselectionFormat) {
                return this.renderMultiSelectionItems();
            }
            else if (this.format === selectionFormat) {
                return this.renderSelectionItems();
            }
            else if (this.format === actionFormat) {
                return this.renderActionItems();
            }
        };
        this.format = undefined;
        this.sectionTitle = undefined;
        this.description = undefined;
        this.items = undefined;
        this.divider = undefined;
        this.currentItems = undefined;
        this.sectionId = this.sectionId;
    }
    parseItemsProp(newValue) {
        if (newValue)
            this.items = JSON.parse(newValue);
    }
    getDataFromProperty(stringToParse) {
        if (stringToParse === 'undefined')
            return;
        try {
            return JSON.parse(stringToParse);
        }
        catch (e) {
            console.error('Could not parse JSON', e);
            if (stringToParse.split(',').length > 0)
                return stringToParse.split(',');
        }
    }
    connectedCallback() {
        // early return if currentItems has already been populated
        if (this.currentItems) {
            return;
        }
        // first render with items data
        if (this.format !== 'action' && typeof this.items === 'string') {
            this.itemsToRender = { items: this.getDataFromProperty(this.items) };
            this.currentItems = this.itemsToRender;
            this.currentItems.sectionTitle = this.sectionTitle;
            this.currentItems.sectionId = this.sectionIdIncremented;
            // @ts-expect-error this.format could not be action in this condition
            this.currentItems.format = this.format;
        }
        else {
            this.itemsToRender = null;
            this.currentItems = this.itemsToRender;
        }
    }
    componentDidLoad() {
        this.moveActionitemIntoListItem();
        this.element.querySelectorAll('.checkbox-box').forEach(item => {
            item.removeAttribute('tabindex');
        });
    }
    moveActionitemIntoListItem() {
        const fragment = document.createDocumentFragment();
        this.element.querySelectorAll('core-dropdown-action-item').forEach(item => {
            const li = fragment.appendChild(document.createElement('li'));
            li.classList.add('list-item-action');
            li.classList.add('item');
            item.disabled && li.classList.add('item--disabled');
            li.classList.add('typography-body-medium-regular');
            li.setAttribute('tabindex', '0');
            li.append(item);
        });
        this.element.querySelector('ul').appendChild(fragment);
    }
    itemSelectionHandler(event) {
        if (this.format !== multiselectionFormat)
            return;
        const target = event.target;
        const targetValue = target.getAttribute('label');
        if (!this.currentItems.selectedItems) {
            this.currentItems.selectedItems = [];
        }
        if (event.detail === true) {
            this.currentItems.selectedItems.push(targetValue);
        }
        else {
            const index = this.currentItems.selectedItems.indexOf(targetValue);
            this.currentItems.selectedItems.splice(index, 1);
        }
        // force rerender with new values
        this.currentItems = Object.assign({}, this.currentItems);
        this.coreDropdownSectionsItemsChange.emit(this.currentItems);
    }
    toggleSelectItem(event, item) {
        if (this.currentItems.format !== selectionFormat || item.disabled)
            return;
        item.selected = !item.selected;
        if (item.selected) {
            this.currentItems.items.forEach(listItem => {
                listItem.selected = false;
            });
            this.element.querySelectorAll('.item-content').forEach(listItemElement => {
                listItemElement.classList.remove(selectedClass);
            });
            item.selected = true;
            event.target.classList.contains('item') && event.target.classList.add(selectedClass);
            this.currentItems.selectedItems = [item.label];
        }
        else {
            event.target.classList.contains('item') && event.target.classList.remove(selectedClass);
            this.currentItems.selectedItems = [];
        }
        // force rerender with new values
        this.currentItems = Object.assign({}, this.currentItems);
        this.coreDropdownSectionsItemsChange.emit(this.currentItems);
    }
    render() {
        return (h(Host, { key: '95dd8b48af393c88316a332fd7c7689b94016d9a', id: this.sectionId, role: "listitem", class: `core-dropdown-section ${this.divider ? 'core-dropdown-section--divided' : ''}` }, this.sectionTitle && (h("span", { class: "section-header" }, h("span", { class: "section-title typography-body-small-bold" }, this.sectionTitle), this.description && h("span", { class: "section-description typography-body-small-regular" }, this.description))), this.renderItems()));
    }
    static get is() { return "core-dropdown-section"; }
    static get properties() {
        return {
            "format": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "SelectionSectionType['format'] | MultipleSelectionSectionType['format'] | ActionSectionType['format']",
                    "resolved": "\"action\" | \"multi-selection\" | \"selection\"",
                    "references": {
                        "SelectionSectionType": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx",
                            "id": "src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx::SelectionSectionType"
                        },
                        "MultipleSelectionSectionType": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx",
                            "id": "src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx::MultipleSelectionSectionType"
                        },
                        "ActionSectionType": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx",
                            "id": "src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx::ActionSectionType"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The format of the section will define the type of items to display."
                },
                "attribute": "format",
                "reflect": false
            },
            "sectionTitle": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Title of the section."
                },
                "attribute": "section-title",
                "reflect": false
            },
            "description": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Description of the section."
                },
                "attribute": "description",
                "reflect": false
            },
            "items": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string | SelectionSectionType['items'] | MultipleSelectionSectionType['items']",
                    "resolved": "CheckboxItemType[] | SelectionItemType[] | string",
                    "references": {
                        "SelectionSectionType": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx",
                            "id": "src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx::SelectionSectionType"
                        },
                        "MultipleSelectionSectionType": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx",
                            "id": "src/components/core-dropdown/components/core-dropdown-section/core-dropdown-section.tsx::MultipleSelectionSectionType"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Items are defined in the `items` property in the `selection` and `multi-selection` format.\nIt is used only for selection purpose.\n\nFor other purposes use the `action` format and the `<core-dropdown-action-item>` component in slot."
                },
                "attribute": "items",
                "reflect": false
            },
            "divider": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Adding a divider on top of the section."
                },
                "attribute": "divider",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "currentItems": {},
            "sectionId": {}
        };
    }
    static get events() {
        return [{
                "method": "coreDropdownSectionsItemsChange",
                "name": "coreDropdownSectionsItemsChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the value has changed."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "items",
                "methodName": "parseItemsProp"
            }];
    }
    static get listeners() {
        return [{
                "name": "coreCheckboxChange",
                "method": "itemSelectionHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=core-dropdown-section.js.map
